export const getLayoutSectionsQuery = () => `
    query getLayoutSections($deviceTypeId: UUID!) {
        layout(deviceTypeId: $deviceTypeId) {
            id
            dependencies {
                source
                sourceValue
                target
                status
                targetValue
            }
            erroneousCombinations {
              condition
              sourceProperty
              targetProperty
            }
            sections {
                id
                name
                order
                status
                displayName
                hasHeaders
                subSections {
                    id
                    name
                    order
                    status
                    displayName
                }
            }
        }
    }
`;

export const getSectionDetailsQuery = () => `
query getLayoutSection($layoutId: UUID!, $sectionId: UUID!) {
    sectionLayout(layoutId: $layoutId, sectionId: $sectionId) {
        id
        headers {
            name
            order
            status
            displayName
            properties {
                name
                order
                status
                displayName
                contentType
                mandatory
                multiSelection
                representationType
                defaultValue
                options {
                  id
                  description
                }
                validations {
                    type
                    ... on MinLengthValidation {
                        length
                    }
                    ... on MinValueValidation {
                        value
                    }
                    ... on MaxLengthValidation {
                        length
                    }
                    ... on MaxValueValidation {
                        value
                    }
                    ... on MaxSelectableValuesValidation {
                        maximum
                    }
                    ... on RegexValidation {
                        regex
                    }
                    ... on AdditionalOnlyValidation {
                        additionalValues
                    }
                    ... on AlphanumericAndAdditionalValidation {
                        additionalValues
                    }
                }
            }
        }
    }
}`;

export const getConfigurationListQuery = () => `
  query getDeviceConfigurationInfo($deviceTypeId: UUID!, $onlyActive: Boolean!) {
      deviceConfigurations(deviceTypeId: $deviceTypeId, onlyActive: $onlyActive) {
          id
          name
          description
          lastModified
          isByDefault
          devicesAssigned
          active
      }
  }
`;

export const copyConfiguration = () => `
    mutation copyConfigurationInstance($instance: CopyConfigurationInstanceInput!) {
        copyConfigurationInstance(instance: $instance)
    }
`;

export const getDeviceConfigurationInstanceQuery = () => `
  query getDeviceConfigurationInstance($deviceConfigurationId: UUID!) {
    configurationInstance(configurationInstanceId: $deviceConfigurationId) {
      id,
      name,
      description,
      lastModified,
      active,
      isByDefault,
      properties {
        name,
        values
      }
    }
  }`;

export const saveDeviceConfigurationInstanceQuery = () => `
  mutation editConfigurationInstance($instance: EditConfigurationInstanceInput!) {
    editConfigurationInstance(instance: $instance)
  }
`;

export const changeConfigurationInstanceToDefaultQuery = () => `
  mutation changeConfigurationInstanceToDefault($deviceConfigurationId: UUID!) {
    changeConfigurationInstanceToDefault(id: $deviceConfigurationId)
  }
`;

export const updateConfigurationInstancesActiveStatusQuery = () => `
mutation updateConfigurationInstancesActiveStatus($configurationInstanceIds: [UUID!]!, $active: Boolean!) {
    updateConfigurationInstancesActiveStatus(configurationInstanceIds: $configurationInstanceIds, active: $active)
}
`;

export const getGeneralDeviceConfigurationQuery = () => `
query generalDeviceConfiguration($deviceTypeId: UUID!) {
    generalDeviceConfiguration(deviceTypeId: $deviceTypeId) {
        id,
        deviceTypeId,
        connectivityProperties {
            enabled,
            warningHours,
            alertHours
        }
        qcProperties {
            levels,
            enabled,
            value,
            qcType
        }
        cleaningProperties {
            enabled,
            warningHours,
            overdueHours,
            showOperatorComments
        }
    }
}
`;

export const updateGeneralDeviceConfigurationQuery = () => `
mutation updateGeneralDeviceConfiguration($deviceTypeId: UUID!, $connectivity: ConnectivityPropertiesUpdate!, $qc: QcPropertiesUpdate!, $cleaning: CleaningPropertiesUpdate) {
    updateGeneralDeviceConfiguration(deviceTypeId: $deviceTypeId, connectivityProperties: $connectivity, qcProperties: $qc, cleaningProperties: $cleaning)
}
`;
